import { IRouteDefinition } from '@estee/elc-router';

import { legacyRampUrlHashRegex, NOT_FOUND_ROUTE_PATTERN } from '~constants/Constants';

import { localeRouteBuilder } from './utils';

export const DEFAULT_ROUTE = 'default';
const DEFAULT_ROUTE_PATTERN = '/';

export const SIGNUP_ROUTE = 'signup';
const SIGNUP_ROUTE_PATTERN = '/signup';

export const CONSENT_ROUTE = 'consent';
const CONSENT_ROUTE_PATTERN = '/consent';

export const ACCOUNT_SIGN_IN_ROUTE = localeRouteBuilder('sign-in');
const ACCOUNT_SIGN_IN_PATTERN = `/${ACCOUNT_SIGN_IN_ROUTE}`;

export const ACCOUNT_SIGN_UP_ROUTE = localeRouteBuilder('sign-up');
const ACCOUNT_SIGN_UP_PATTERN = `/${ACCOUNT_SIGN_UP_ROUTE}`;

export const ACCOUNT_GUEST_CHECKOUT_ROUTE = localeRouteBuilder('guest-checkout');
const ACCOUNT_GUEST_CHECKOUT_PATTERN = `/${ACCOUNT_GUEST_CHECKOUT_ROUTE}`;

const SOCIAL_PROFILE_ROUTE = 'profile';
const SOCIAL_PROFILE_ROUTE_PATTERN = '/profile';

export const NOT_FOUND_ROUTE = 'notFound';

export const QRCODE_ROUTE = 'thankyou';
const QRCODE_ROUTE_PATTERN = '/thankyou';

export const REDIRECT_ROUTE = 'redirect';
const REDIRECT_ROUTE_PATTERN = '/redirect';

export const SUCCESS_ROUTE = 'success';
const SUCCESS_ROUTE_PATTERN = '/success';

export const SOCIAL_SIGN_UP_ROUTE = 'social-sign-up';
const SOCIAL_SIGN_UP_ROUTE_PATTERN = '/social-sign-up';

export const IN_STORE_SIGN_UP_ROUTE = 'in-store-sign-up';
const IN_STORE_SIGN_UP_ROUTE_PATTERN = '/in-store-sign-up';

export const ACCOUNT_PREFERENCE_URL = `/${localeRouteBuilder('account/profile_preferences.tmpl')}`;
export const ACCOUNT_HOME_URL = `/${localeRouteBuilder('account/index.tmpl')}`;
export const ACCOUNT_HOME_IKALAR_ANCHOR = `${ACCOUNT_HOME_URL}#accountikalar`;
export const ACCOUNT_FORGOT_PASSWORD_URL = `/${localeRouteBuilder(
    'account/password_request.tmpl'
)}`;
export const CART_URL = `/${localeRouteBuilder('checkout/viewcart.tmpl')}`;

export const SOCIAL_SIGN_UP_SUCCESS_ROUTE = 'registerSuccess';
const SOCIAL_SIGN_UP_SUCCESS_ROUTE_PATTERN = '/register-success';

export const SOCIAL_SIGN_UP_PROFILE_ERROR_ROUTE = 'profileError';
const SOCIAL_SIGN_UP_PROFILE_ERROR_ROUTE_PATTERN = '/profile-error';

export type InternalRouteType =
    | typeof QRCODE_ROUTE
    | typeof REDIRECT_ROUTE
    | typeof SOCIAL_SIGN_UP_SUCCESS_ROUTE
    | typeof SUCCESS_ROUTE;

export type ExternalRouteType = typeof ACCOUNT_HOME_URL | typeof ACCOUNT_PREFERENCE_URL;

export const ROUTES: IRouteDefinition[] = [
    {
        name: DEFAULT_ROUTE,
        pattern: DEFAULT_ROUTE_PATTERN
    },
    {
        name: SIGNUP_ROUTE,
        pattern: SIGNUP_ROUTE_PATTERN
    },
    {
        name: CONSENT_ROUTE,
        pattern: CONSENT_ROUTE_PATTERN
    },
    {
        name: ACCOUNT_SIGN_IN_ROUTE,
        pattern: ACCOUNT_SIGN_IN_PATTERN
    },
    {
        name: ACCOUNT_SIGN_UP_ROUTE,
        pattern: ACCOUNT_SIGN_UP_PATTERN
    },
    {
        name: ACCOUNT_GUEST_CHECKOUT_ROUTE,
        pattern: ACCOUNT_GUEST_CHECKOUT_PATTERN
    },
    {
        name: SOCIAL_PROFILE_ROUTE,
        pattern: SOCIAL_PROFILE_ROUTE_PATTERN
    },
    {
        name: QRCODE_ROUTE,
        pattern: QRCODE_ROUTE_PATTERN
    },
    {
        name: SOCIAL_SIGN_UP_SUCCESS_ROUTE,
        pattern: SOCIAL_SIGN_UP_SUCCESS_ROUTE_PATTERN
    },
    {
        name: SOCIAL_SIGN_UP_PROFILE_ERROR_ROUTE,
        pattern: SOCIAL_SIGN_UP_PROFILE_ERROR_ROUTE_PATTERN
    },
    {
        name: SUCCESS_ROUTE,
        pattern: SUCCESS_ROUTE_PATTERN
    },
    {
        name: REDIRECT_ROUTE,
        pattern: REDIRECT_ROUTE_PATTERN
    },
    {
        name: NOT_FOUND_ROUTE,
        pattern: NOT_FOUND_ROUTE_PATTERN
        // TODO: redirect to external not-found page
    },
    {
        name: SOCIAL_SIGN_UP_ROUTE,
        pattern: SOCIAL_SIGN_UP_ROUTE_PATTERN
    },
    {
        name: IN_STORE_SIGN_UP_ROUTE,
        pattern: IN_STORE_SIGN_UP_ROUTE_PATTERN,
        beforeEnter: async () => {
            const { pathname, hash } = window.location;
            if (legacyRampUrlHashRegex.test(hash)) {
                const query = hash.substring(hash.indexOf('?'));
                window.history.replaceState(null, '', `${pathname}${query}`);
            }

            return Promise.resolve();
        }
    }
];
